import React, { FC, useContext, useEffect, useState } from 'react'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { tabListSoleTrader, tabListViewer, tabListExecutor, tabListDefault, ITabList, tabListAdmin } from './tabList'
import { AppStateContext } from '../../../../components/Context'
import { userPermissionEnum } from '../../../../constants/userPermissions'
import { TabsComponentMemo } from '../../../../components/Dashboard/Tabs'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}))

export const Treasury: FC = () => {
  const classes = useStyles()
  const { getUserRole } = useContext(AppStateContext)
  const [userRole, setUserRole] = useState<string>()
  const [tabList, setTabList] = useState<ITabList[]>([])

  useEffect(() => setUserRole(getUserRole()), [setUserRole, getUserRole])

  useEffect(() => {
    if (userRole) {
      switch (userRole) {
        case userPermissionEnum.admin:
          setTabList(tabListAdmin)
          break
        case userPermissionEnum.sole_trader:
          setTabList(tabListSoleTrader)
          break
        case userPermissionEnum.executor:
          setTabList(tabListExecutor)
          break
        case userPermissionEnum.viewer:
          setTabList(tabListViewer)
          break
        default:
          setTabList(tabListDefault)
          break
      }
    }
  }, [userRole])

  return (
    <section className={classes.container}>
      {tabList.length > 0 && <TabsComponentMemo tabList={tabList} twoButtons />}
    </section>
  )
}
